export default function (productId) {
    return new Promise((resolve) => {
        $.request('onCartUpdateModifications', {
            method: 'POST',
            data: {
                product_id: productId
            }
        }).then(resolve);
    });
}